import React, { useEffect, useState } from 'react';
import axios from '../../utils/axiosInstance';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrash, FaEye } from 'react-icons/fa';
import { toastSuccess, toastError } from '../../utils/alertHelper';
import UserFilters from '../../components/commonComponent/UserFilters';

const Vanueindex = () => {
  const [venues, setVenues] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showFilters, setShowFilters] = useState(false);

  const [filters, setFilters] = useState({
    cluster: '',
    role: '',
    responsibility: '',
    chapter: '',
    startDate: '',
    endDate: ''
  });

  const [dropdowns, setDropdowns] = useState({
    clusters: [],
    roles: [],
    responsibilities: [],
    chapters: []
  });

 const limit = parseInt(process.env.REACT_APP_PAGE_LIMIT || 10); 

  // Fetch dropdown options once on mount
  // useEffect(() => {
  //   fetchDropdownOptions();
  // }, []);

  // Fetch users when currentPage, searchQuery or filters change
  useEffect(() => {
    fetchVenues(currentPage, searchQuery, filters);
  }, [currentPage, searchQuery, filters]);

  // const fetchDropdownOptions = async () => {
  //   try {
  //     const [rolesRes, clustersRes, chaptersRes, responsibilitiesRes] = await Promise.all([
  //       axios.get('/admin/api/role'),
  //       axios.get('/admin/api/clusters/all'),
  //       axios.get('/admin/api/chapters/all'),
  //       axios.get('/admin/api/responsibility/all'),
  //     ]);

  //     setDropdowns({
  //       roles: rolesRes.data?.roles?.map(r => ({ value: r._id, label: r.name })) || [],
  //       clusters: clustersRes.data?.cluster?.map(c => ({ value: c._id, label: c.name })) || [],
  //       chapters: chaptersRes.data?.chapter?.map(ch => ({ value: ch._id, label: ch.name })) || [],
  //       responsibilities: responsibilitiesRes.data?.responsibility?.map(res => ({ value: res._id, label: res.name })) || [],
  //     });
  //   } catch (err) {
  //     toastError('Failed to load filter dropdowns');
  //     console.error(err);
  //   }
  // };

  const fetchVenues = async (page = 1, search = '', filtersData = filters) => {
    try {
      const params = new URLSearchParams({
        page,
        limit,
        search,
        // cluster: filtersData.cluster || '',
        // role: filtersData.role || '',
        // responsibility: filtersData.responsibility || '',
        // chapter: filtersData.chapter || '',
        startDate: filtersData.startDate || '',
        endDate: filtersData.endDate || '',
      });

      const res = await axios.get(`/admin/api/venues?${params.toString()}`);
      const { venues = [], totalCount = 0 } = res.data;
      setVenues(venues);
      setTotalPages(Math.ceil(totalCount / limit));
    } catch (err) {
      toastError('Failed to fetch venue');
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/admin/api/venues/${id}`);
      toastSuccess('Venue deleted successfully!');
      setCurrentPage(1);
      fetchVenues(1, searchQuery, filters);
    } catch (err) {
      toastError('Failed to delete user');
      console.error(err);
    }
  };

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setFilters({
      cluster: '',
      role: '',
      responsibility: '',
      chapter: '',
      startDate: '',
      endDate: ''
    });
    setSearchQuery('');
    setCurrentPage(1);
  };

  return (
    <div className="container mt-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0 text-dark"> Venue</h3>

        <div className="d-flex align-items-center">
          <input
            type="text"
            className="form-control w-75"
            placeholder="Search Vanue..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="mb-0 text-dark">All Venue</h5>
          <Link to="/vanue/create" className="btn btn-sm"
            style={{ backgroundColor: '#C44C23', color: '#fff' }}>
            + Add New Vanue
          </Link>
        </div>

        <div className="card-body p-0">
          <table
            className="table table-bordered table-sm mb-0"
            style={{ fontSize: '14px', lineHeight: '2' }}
          >
            <thead className="table-light">
              <tr>
                <th className="py-1 px-2">Sr no.</th>
                <th className="py-1 px-2">Venue Name</th>
                <th className="py-1 px-2">Google Link</th>
                <th className="py-1 px-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {venues.length > 0 ? (
                venues.map((v, idx) => (
                  <tr key={v._id}>
                    <td>{(currentPage - 1) * limit + idx + 1}</td>
                    <td>{v.venueName || v.name}</td>
                    <td>{v.googleLink}</td>
                    <td>
        
                      <Link
                        to={`/vanue/edit/${v._id}`}
                        className="btn btn-sm me-1 py-0 px-2"
                        style={{
                          fontSize: '12px',
                          lineHeight: '1.2',
                          boxShadow: 'none',
                          color: '#C44C23',
                          border: 'none'
                        }}
                        title="Edit"
                      >
                        <FaEdit size={14} />
                      </Link>
                      <button
                        className="btn btn-sm me-1 py-0 px-2"
                        style={{
                          fontSize: '12px',
                          lineHeight: '1.2',
                          boxShadow: 'none',
                          color: '#C44C23',
                          border: 'none'
                        }}
                        title="Delete"
                        onClick={() => handleDelete(v._id)}
                      >
                        <FaTrash size={14} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">No Venue found.</td>
                </tr>
              )}
            </tbody>
          </table>

          {totalPages > 1 && (
            <div className="d-flex justify-content-end align-items-center gap-2 p-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                &laquo;
              </button>

              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  className="btn btn-sm"
                  style={{
                    backgroundColor: currentPage === page ? '#C44C23' : 'transparent',
                    color: currentPage === page ? 'white' : '#C44C23',
                    border: '1px solid #C44C23'
                  }}
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ))}

              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                &raquo;
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Vanueindex;
